import { Alert, Box } from '@zillow/constellation-10';

import { useSelector } from '../../selectors/useSelector';

import accessUtils from '../../utils/accessUtils';

const SFCostAndFeesTotalMonthlyPriceWithFeeAlert = () => {
  const { appConfig, cookieEnabledServices } = useSelector((state) => ({
    appConfig: state?.app?.appConfig,
    cookieEnabledServices: state?.app?.cookieEnabledServices,
  }));

  const canAccessUpdatedTotalMonthlyPriceCopy = accessUtils.canAccessUpdatedTotalMonthlyPriceCopy({
    appConfig,
    cookieEnabledServices,
  });

  return (
    <Box data-testid="SFCostAndFeesTotalMonthlyPriceWithFeeAlert" css={{ marginBottom: '600' }}>
      <Alert role="alert">
        Any required monthly fees will be combined with base rent and a{' '}
        {canAccessUpdatedTotalMonthlyPriceCopy ? '"total monthly price"' : '"total price"'} label will be added to your
        listing. You can also indicate if certain fees are already included in base rent.
      </Alert>
    </Box>
  );
};

export default SFCostAndFeesTotalMonthlyPriceWithFeeAlert;
